import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';

export default function SnackBarError({
  state,
  handleCloseSnackBarError
}) {
  
  const { vertical, horizontal, open, message } = state;

  return (
    <Box sx={{ width: 500 }}>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleCloseSnackBarError}
        autoHideDuration={3000}
        message={
          <span
            style={{
              color: 'red',
              textShadow: '1px 1px 4px rgba(0,0,0,0.7)',
              fontWeight: 'bold'
            }}
          >
            {message}
          </span>
        }
        ContentProps={{
          sx: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
        key={vertical + horizontal}
      />
    </Box>
  );
}
